import {SubDistrictStatusType} from 'constants/index';
import {StoreAreas, UserAddress} from 'types';
import {SubDistrict} from 'types/location';

export const locationToStoreAreas = (locations: SubDistrict[]): StoreAreas[] => {
  if (!locations?.length) {
    return [];
  }

  return locations.map((location) => ({
    s: location.nameTh,
    p: location.district?.province?.nameTh,
    d: location.district?.nameTh,
    z: location.zipCode,
    se: location.nameEn,
    de: location.district?.nameEn,
    pe: location.district?.province?.nameEn,
    status: SubDistrictStatusType.DELIVERABLE,
    pID: location.district?.province?.id,
    dID: location.district?.id,
    sID: location.code
  })) as StoreAreas[];
};

export const checkIfAddressLocationIsDeliverable = (
  locations: StoreAreas[] | null,
  shippingAddress: UserAddress
): boolean => {
  return !(
    locations?.length &&
    !!locations.find(
      (loc) =>
        loc.z === shippingAddress.zip &&
        loc.sID === shippingAddress.subDistrict?.id &&
        loc.status === SubDistrictStatusType.DELIVERABLE
    )
  );
};
